import React, { useState, useEffect } from '../../../node_modules/react'
import "./style.scss"
import { Link } from 'react-router-dom'
// import icon1 from '../../assets/imagens/home-rep.jpg'
// import icon2 from '../../assets/imagens/home-loj.jpg'
// import icon3 from '../../assets/imagens/home-con.JPG'
// import icon4 from '../../assets/imagens/home-ins.jpg'
// import icon5 from '../../assets/imagens/home-pre.jpg'

import img1 from '../../assets/imagens/home-rep.JPG'
import img2 from '../../assets/imagens/home-loj.a504a0ba.JPG'
import img3 from '../../assets/imagens/home-con.11f170b1.JPG'
import img4 from '../../assets/imagens/home-ins.JPG'
import img5 from '../../assets/imagens/home-pre.811aae8c.JPG'
import img6 from '../../assets/imagens/home-web.6bf3b9a8.JPG'



const Personas = () => {

  return (
    <>
      <div className="container personas">
        <Link to="/reputacao-de-lojas" className="personas__div-link-personas">
          <div className="personas__div-link-personas__card blue">
            <h4 className="personas__div-link-personas__card__title-home">Reputação de lojas</h4>
            {/* <h5 className="personas__div-link-personas__card__sub-title">Busque pelas lojas mais confiáveis</h5> */}
            <p>Busque pela reputação das lojas online, avaliada pelos consumidores.</p>
            <div className="blue">
              <img src={img1} alt="" />
            </div>
          </div>
        </Link>

        <Link to="/empresa" className="personas__div-link-personas">
          <div className="personas__div-link-personas__card gold">
            <h4 className="personas__div-link-personas__card__title-home">Quero ser um lojista colaborador</h4>
            {/* <p>Confira os mais completos relatórios sobre o mercado de e-commerce.</p> */}
            <p>A reputação Ebit | Nielsen contribui com aumento de tráfego, conversão e SEO.</p>
            <div className="gold">
              <img src={img6} alt="" />
            </div>
          </div>
        </Link>

        

        <Link to="/lojista" className="personas__div-link-personas">
          <div className="personas__div-link-personas__card purple">
            <h4 className="personas__div-link-personas__card__title-home">Já sou um Lojista Colaborador</h4>
            <p>Credibilidade para o seu e-commerce e inteligência competitiva para o seu negócio, sem custo.</p>
            <div className="purple">
              <img src={img2} alt="" />
            </div>
          </div>
        </Link>

        <Link to="/consumidor" className="personas__div-link-personas">
          <div className="personas__div-link-personas__card green">
            <h4 className="personas__div-link-personas__card__title-home">Consumidor</h4>
            <p> A Ebit | Nielsen está presente em várias etapas de compras online.</p>
            <div className="green">
              <img src={img3} alt="" />
            </div>
          </div>
        </Link>

        <Link to="/premio-ebit" className="personas__div-link-personas">
          <div className="personas__div-link-personas__card gray">
            <h4 className="personas__div-link-personas__card__title-home">Prêmio Ebit | Nielsen</h4>
            <p> Uma iniciativa da Ebit | Nielsen, é a premiação mais tradicional desse segmento.</p>
            <div className="gray">
              <img src={img5} alt="" />
            </div>
          </div>
        </Link>

        <Link to="/webshoppers" className="personas__div-link-personas">
          <div className="personas__div-link-personas__card red">
            <h4 className="personas__div-link-personas__card__title-home">Webshoppers</h4>
            <p>Confira os mais completos relatórios sobre o mercado de e-commerce.</p>
            <div className="red">
              <img src={img4} alt="" />
            </div>
          </div>
        </Link>
      </div>
    </>
  )
}
export default Personas